import React from 'react';
import styled from 'styled-components';
import logoImg from '../assets/img/logoAutofactWhite.svg';

function Footer() {
  return (
    <ContainerFooter>
      <img height={28} width={95} src={logoImg} alt="autofact" />
    </ContainerFooter>
  );
}

export default Footer;

const ContainerFooter = styled.div`
  background-color: #15257A;
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
